!function(root, factory) {
    "object" == typeof exports && "object" == typeof module ? module.exports = factory() : "function" == typeof define && define.amd ? define([], factory) : "object" == typeof exports ? exports["vue-js-modal"] = factory() : root["vue-js-modal"] = factory();
}("undefined" != typeof self ? self : this, function() {
    return function(modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.l = !0, module.exports;
        }
        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        }, __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "/dist/", __webpack_require__(__webpack_require__.s = 5);
    }([ function(module, exports) {
        module.exports = function() {
            var list = [];
            return list.toString = function() {
                for (var result = [], i = 0; i < this.length; i++) {
                    var item = this[i];
                    item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
                }
                return result.join("");
            }, list.i = function(modules, mediaQuery) {
                "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
                for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                    var id = this[i][0];
                    "number" == typeof id && (alreadyImportedModules[id] = !0);
                }
                for (i = 0; i < modules.length; i++) {
                    var item = modules[i];
                    "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                    list.push(item));
                }
            }, list;
        };
    }, function(module, exports, __webpack_require__) {
        function addStylesToDom(styles) {
            for (var i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                if (domStyle) {
                    domStyle.refs++;
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                    for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j]));
                    domStyle.parts.length > item.parts.length && (domStyle.parts.length = item.parts.length);
                } else {
                    for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j]));
                    stylesInDom[item.id] = {
                        id: item.id,
                        refs: 1,
                        parts: parts
                    };
                }
            }
        }
        function createStyleElement() {
            var styleElement = document.createElement("style");
            return styleElement.type = "text/css", head.appendChild(styleElement), styleElement;
        }
        function addStyle(obj) {
            var update, remove, styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]');
            if (styleElement) {
                if (isProduction) return noop;
                styleElement.parentNode.removeChild(styleElement);
            }
            if (isOldIE) {
                var styleIndex = singletonCounter++;
                styleElement = singletonElement || (singletonElement = createStyleElement()), update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), 
                remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
            } else styleElement = createStyleElement(), update = applyToTag.bind(null, styleElement), 
            remove = function() {
                styleElement.parentNode.removeChild(styleElement);
            };
            return update(obj), function(newObj) {
                if (newObj) {
                    if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                    update(obj = newObj);
                } else remove();
            };
        }
        function applyToSingletonTag(styleElement, index, remove, obj) {
            var css = remove ? "" : obj.css;
            if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
                var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
                childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
            }
        }
        function applyToTag(styleElement, obj) {
            var css = obj.css, media = obj.media, sourceMap = obj.sourceMap;
            if (media && styleElement.setAttribute("media", media), sourceMap && (css += "\n/*# sourceURL=" + sourceMap.sources[0] + " */", 
            css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */"), 
            styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
                for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
                styleElement.appendChild(document.createTextNode(css));
            }
        }
        var hasDocument = "undefined" != typeof document;
        if ("undefined" != typeof DEBUG && DEBUG && !hasDocument) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");
        var listToStyles = __webpack_require__(11), stylesInDom = {}, head = hasDocument && (document.head || document.getElementsByTagName("head")[0]), singletonElement = null, singletonCounter = 0, isProduction = !1, noop = function() {}, isOldIE = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());
        module.exports = function(parentId, list, _isProduction) {
            isProduction = _isProduction;
            var styles = listToStyles(parentId, list);
            return addStylesToDom(styles), function(newList) {
                for (var mayRemove = [], i = 0; i < styles.length; i++) {
                    var item = styles[i], domStyle = stylesInDom[item.id];
                    domStyle.refs--, mayRemove.push(domStyle);
                }
                newList ? (styles = listToStyles(parentId, newList), addStylesToDom(styles)) : styles = [];
                for (var i = 0; i < mayRemove.length; i++) {
                    var domStyle = mayRemove[i];
                    if (0 === domStyle.refs) {
                        for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                        delete stylesInDom[domStyle.id];
                    }
                }
            };
        };
        var replaceText = function() {
            var textStore = [];
            return function(index, replacement) {
                return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
            };
        }();
    }, function(module, exports) {
        module.exports = function(rawScriptExports, compiledTemplate, scopeId, cssModules) {
            var esModule, scriptExports = rawScriptExports = rawScriptExports || {}, type = typeof rawScriptExports.default;
            "object" !== type && "function" !== type || (esModule = rawScriptExports, scriptExports = rawScriptExports.default);
            var options = "function" == typeof scriptExports ? scriptExports.options : scriptExports;
            if (compiledTemplate && (options.render = compiledTemplate.render, options.staticRenderFns = compiledTemplate.staticRenderFns), 
            scopeId && (options._scopeId = scopeId), cssModules) {
                var computed = options.computed || (options.computed = {});
                Object.keys(cssModules).forEach(function(key) {
                    var module = cssModules[key];
                    computed[key] = function() {
                        return module;
                    };
                });
            }
            return {
                esModule: esModule,
                exports: scriptExports,
                options: options
            };
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var sizingHandleCssClassNames = (exports.SizingHandleType = {
            TopLeft: "TopLeft",
            Top: "Top",
            TopRight: "TopRight",
            Left: "Left",
            Right: "Right",
            BottomLeft: "BottomLeft",
            Bottom: "Bottom",
            BottomRight: "BottomRight"
        }, {
            TopLeft: "vue-modal-resizer-tl",
            Top: "vue-modal-resizer-tc",
            TopRight: "vue-modal-resizer-tr",
            Left: "vue-modal-resizer-left",
            Right: "vue-modal-resizer-right",
            BottomLeft: "vue-modal-resizer-bl",
            Bottom: "vue-modal-resizer-bc",
            BottomRight: "vue-modal-resizer-br"
        });
        exports.getCssClassForSizingHandleType = function(type) {
            return sizingHandleCssClassNames[type];
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, types = [ {
            name: "px",
            regexp: new RegExp("^[-+]?[0-9]*.?[0-9]+px$")
        }, {
            name: "%",
            regexp: new RegExp("^[-+]?[0-9]*.?[0-9]+%$")
        }, {
            name: "px",
            regexp: new RegExp("^[-+]?[0-9]*.?[0-9]+$")
        } ], getType = function(value) {
            if ("auto" === value) return {
                type: value,
                value: 0
            };
            for (var i = 0; i < types.length; i++) {
                var type = types[i];
                if (type.regexp.test(value)) return {
                    type: type.name,
                    value: parseFloat(value)
                };
            }
            return {
                type: "",
                value: value
            };
        }, parse = exports.parse = function(value) {
            switch (void 0 === value ? "undefined" : _typeof(value)) {
              case "number":
                return {
                    type: "px",
                    value: value
                };

              case "string":
                return getType(value);

              default:
                return {
                    type: "",
                    value: value
                };
            }
        };
        exports.default = parse;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _Modal = __webpack_require__(8), _Modal2 = _interopRequireDefault(_Modal), _Dialog = __webpack_require__(23), _Dialog2 = _interopRequireDefault(_Dialog), _PanelResizer = __webpack_require__(28), _PanelResizer2 = _interopRequireDefault(_PanelResizer), Plugin = {
            install: function(Vue) {
                var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (!this.installed) {
                    this.installed = !0, this.event = new Vue(), Vue.prototype.$modal = {
                        show: function(name, params) {
                            Plugin.event.$emit("toggle", name, !0, params);
                        },
                        hide: function(name, params) {
                            Plugin.event.$emit("toggle", name, !1, params);
                        },
                        toggle: function(name, params) {
                            Plugin.event.$emit("toggle", name, void 0, params);
                        },
                        moveTo: function(name, params) {
                            Plugin.event.$emit("moveTo", name, params);
                        },
                        resize: function(name, params) {
                            Plugin.event.$emit("resize", name, params);
                        }
                    };
                    var componentName = options.componentName || "modal";
                    Vue.component(componentName, _Modal2.default), options.dialog && Vue.component("v-dialog", _Dialog2.default), 
                    Vue.component("panel-resizer", _PanelResizer2.default);
                }
            }
        };
        exports.default = Plugin;
    }, function(module, exports, __webpack_require__) {
        __webpack_require__(17);
        var Component = __webpack_require__(2)(__webpack_require__(19), __webpack_require__(20), null, null);
        Component.options.__file = "C:\\www\\tombola-vue-js-modal\\src\\Resizer.vue", Component.esModule && Object.keys(Component.esModule).some(function(key) {
            return "default" !== key && "__esModule" !== key;
        }) && console.error("named exports are not supported in *.vue files."), Component.options.functional && console.error("[vue-loader] Resizer.vue: functional components are not supported with templates, they should use render functions."), 
        exports.__esModule = !0, exports.default = Component.exports;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var inRange = exports.inRange = function(from, to, value) {
            return value < from ? from : value > to ? to : value;
        };
        exports.default = {
            inRange: inRange
        };
    }, function(module, exports, __webpack_require__) {
        __webpack_require__(9);
        var Component = __webpack_require__(2)(__webpack_require__(12), __webpack_require__(22), null, null);
        Component.options.__file = "C:\\www\\tombola-vue-js-modal\\src\\Modal.vue", Component.esModule && Object.keys(Component.esModule).some(function(key) {
            return "default" !== key && "__esModule" !== key;
        }) && console.error("named exports are not supported in *.vue files."), Component.options.functional && console.error("[vue-loader] Modal.vue: functional components are not supported with templates, they should use render functions."), 
        exports.__esModule = !0, exports.default = Component.exports;
    }, function(module, exports, __webpack_require__) {
        var content = __webpack_require__(10);
        "string" == typeof content && (content = [ [ module.i, content, "" ] ]), content.locals && (module.exports = content.locals);
        __webpack_require__(1)("147fde29", content, !1);
    }, function(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(0)(), exports.push([ module.i, "\n.v--modal-block-scroll {\r\n  position: absolute;\r\n  overflow: hidden;\r\n  width: 100vw;\n}\n.v--modal-overlay {\r\n  position: fixed;\r\n  box-sizing: border-box;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  z-index: 999;\r\n  opacity: 1;\n}\n.v--modal-overlay.scrollable {\r\n  height: 100%;\r\n  min-height: 100vh;\r\n  overflow-y: auto;\r\n  padding-bottom: 10px;\r\n  -webkit-overflow-scrolling: touch;\n}\n.v--modal-overlay .v--modal-box {\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-sizing: border-box;\n}\n.v--modal-overlay.scrollable .v--modal-box {\r\n  margin-bottom: 2px;\r\n  /* transition: top 0.2s ease; */\n}\n.v--modal {\r\n  background-color: white;\r\n  text-align: left;\r\n  border-radius: 3px;\r\n  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\r\n  padding: 0;\n}\n.v--modal.v--modal-fullscreen {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\n}\n.v--modal-top-right {\r\n  display: block;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\n}\n.overlay-fade-enter-active,\r\n.overlay-fade-leave-active {\r\n  transition: all 0.2s;\n}\n.overlay-fade-enter,\r\n.overlay-fade-leave-active {\r\n  opacity: 0;\n}\n.nice-modal-fade-enter-active,\r\n.nice-modal-fade-leave-active {\r\n  transition: all 0.4s;\n}\n.nice-modal-fade-enter,\r\n.nice-modal-fade-leave-active {\r\n  opacity: 0;\r\n  transform: translateY(-20px);\n}\r\n", "", {
            version: 3,
            sources: [ "/./src/Modal.vue" ],
            names: [],
            mappings: ";AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;CACd;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,WAAW;CACZ;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;CACnC;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;CACxB;AACD;EACE,mBAAmB;EACnB,gCAAgC;CACjC;AACD;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;EACnD,WAAW;CACZ;AACD;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,QAAQ;EACR,OAAO;CACR;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,OAAO;CACR;AACD;;EAEE,qBAAqB;CACtB;AACD;;EAEE,WAAW;CACZ;AACD;;EAEE,qBAAqB;CACtB;AACD;;EAEE,WAAW;EACX,6BAA6B;CAC9B",
            file: "Modal.vue",
            sourcesContent: [ "\n.v--modal-block-scroll {\r\n  position: absolute;\r\n  overflow: hidden;\r\n  width: 100vw;\n}\n.v--modal-overlay {\r\n  position: fixed;\r\n  box-sizing: border-box;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  z-index: 999;\r\n  opacity: 1;\n}\n.v--modal-overlay.scrollable {\r\n  height: 100%;\r\n  min-height: 100vh;\r\n  overflow-y: auto;\r\n  padding-bottom: 10px;\r\n  -webkit-overflow-scrolling: touch;\n}\n.v--modal-overlay .v--modal-box {\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-sizing: border-box;\n}\n.v--modal-overlay.scrollable .v--modal-box {\r\n  margin-bottom: 2px;\r\n  /* transition: top 0.2s ease; */\n}\n.v--modal {\r\n  background-color: white;\r\n  text-align: left;\r\n  border-radius: 3px;\r\n  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\r\n  padding: 0;\n}\n.v--modal.v--modal-fullscreen {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\n}\n.v--modal-top-right {\r\n  display: block;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\n}\n.overlay-fade-enter-active,\r\n.overlay-fade-leave-active {\r\n  transition: all 0.2s;\n}\n.overlay-fade-enter,\r\n.overlay-fade-leave-active {\r\n  opacity: 0;\n}\n.nice-modal-fade-enter-active,\r\n.nice-modal-fade-leave-active {\r\n  transition: all 0.4s;\n}\n.nice-modal-fade-enter,\r\n.nice-modal-fade-leave-active {\r\n  opacity: 0;\r\n  transform: translateY(-20px);\n}\r\n" ],
            sourceRoot: "webpack://"
        } ]);
    }, function(module, exports) {
        module.exports = function(parentId, list) {
            for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
                var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                    id: parentId + ":" + i,
                    css: css,
                    media: media,
                    sourceMap: sourceMap
                };
                newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                    id: id,
                    parts: [ part ]
                });
            }
            return styles;
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _index = __webpack_require__(5), _index2 = _interopRequireDefault(_index), _ResizerFrame = __webpack_require__(13), _ResizerFrame2 = _interopRequireDefault(_ResizerFrame), _util = __webpack_require__(7), _parser = __webpack_require__(4), _parser2 = _interopRequireDefault(_parser);
        exports.default = {
            name: "VueJsModal",
            props: {
                name: {
                    required: !0,
                    type: String
                },
                delay: {
                    type: Number,
                    default: 0
                },
                resizable: {
                    type: Boolean,
                    default: !1
                },
                adaptive: {
                    type: Boolean,
                    default: !1
                },
                draggable: {
                    type: [ Boolean, String ],
                    default: !1
                },
                scrollable: {
                    type: Boolean,
                    default: !1
                },
                reset: {
                    type: Boolean,
                    default: !1
                },
                transition: {
                    type: String
                },
                clickToClose: {
                    type: Boolean,
                    default: !0
                },
                classes: {
                    type: [ String, Array ],
                    default: "v--modal"
                },
                minWidth: {
                    type: Number,
                    default: 100,
                    validator: function(value) {
                        return value >= 0;
                    }
                },
                minHeight: {
                    type: Number,
                    default: 200,
                    validator: function(value) {
                        return value >= 0;
                    }
                },
                maxWidth: {
                    type: Number,
                    default: 1 / 0
                },
                maxHeight: {
                    type: Number,
                    default: 1 / 0
                },
                width: {
                    type: [ Number, String ],
                    default: 600,
                    validator: function(value) {
                        if ("string" == typeof value) {
                            var width = (0, _parser2.default)(value);
                            return ("%" === width.type || "px" === width.type) && width.value > 0;
                        }
                        return value >= 0;
                    }
                },
                height: {
                    type: [ Number, String ],
                    default: 300,
                    validator: function(value) {
                        if ("string" == typeof value) {
                            if ("auto" === value) return !0;
                            var height = (0, _parser2.default)(value);
                            return ("%" === height.type || "px" === height.type) && height.value > 0;
                        }
                        return value >= 0;
                    }
                },
                pivotX: {
                    type: Number,
                    default: 0,
                    validator: function(value) {
                        return value >= 0 && value <= 1;
                    }
                },
                pivotY: {
                    type: Number,
                    default: 0,
                    validator: function(value) {
                        return value >= 0 && value <= 1;
                    }
                },
                container: {
                    type: String
                },
                snapGridSize: {
                    type: Number,
                    default: 4,
                    validator: function(value) {
                        return value > 0;
                    }
                },
                autoSnapToGrid: {
                    type: Boolean,
                    default: !1
                }
            },
            components: {
                ResizerFrame: _ResizerFrame2.default
            },
            data: function() {
                return {
                    visible: !1,
                    visibility: {
                        modal: !1,
                        overlay: !1
                    },
                    shift: {
                        left: 0,
                        top: 0
                    },
                    shiftCache: {
                        left: 0,
                        top: 0
                    },
                    modal: {
                        width: 0,
                        widthType: "px",
                        height: 0,
                        heightType: "px",
                        renderedHeight: 0
                    },
                    window: {
                        width: 0,
                        height: 0
                    },
                    mutationObserver: null
                };
            },
            watch: {
                visible: function(value) {
                    var _this = this;
                    value ? (this.visibility.overlay = !0, setTimeout(function() {
                        _this.visibility.modal = !0, _this.$nextTick(function() {
                            _this.addDraggableListeners(), _this.callAfterEvent(!0);
                        });
                    }, this.delay)) : (this.visibility.modal = !1, setTimeout(function() {
                        _this.visibility.overlay = !1, _this.$nextTick(function() {
                            _this.removeDraggableListeners(), _this.callAfterEvent(!1);
                        });
                    }, this.delay));
                }
            },
            created: function() {
                this.setInitialSize();
            },
            beforeMount: function() {
                var _this2 = this;
                if (_index2.default.event.$on("toggle", function(name, state, params) {
                    name === _this2.name && (void 0 === state && (state = !_this2.visible), _this2.toggle(state, params));
                }), _index2.default.event.$on("moveTo", function(name, params) {
                    name === _this2.name && _this2.moveTo(params);
                }), _index2.default.event.$on("resize", function(name, params) {
                    name === _this2.name && _this2.resize(params);
                }), window.addEventListener("resize", this.onWindowResize), this.onWindowResize(), 
                this.scrollable && !this.isAutoHeight && console.warn('Modal "' + this.name + '" has scrollable flag set to true but height is not "auto" (' + this.height + ")"), 
                this.isAutoHeight) {
                    var MutationObserver = function() {
                        for (var prefixes = [ "", "WebKit", "Moz", "O", "Ms" ], i = 0; i < prefixes.length; i++) {
                            var name = prefixes[i] + "MutationObserver";
                            if (name in window) return window[name];
                        }
                        return !1;
                    }();
                    MutationObserver && (this.mutationObserver = new MutationObserver(function(mutations) {
                        _this2.updateRenderedHeight();
                    }));
                }
                this.clickToClose && window.addEventListener("keyup", this.onEscapeKeyUp);
            },
            beforeDestroy: function() {
                window.removeEventListener("resize", this.onWindowResize), this.clickToClose && window.removeEventListener("keyup", this.onEscapeKeyUp);
            },
            computed: {
                isAutoHeight: function() {
                    return "auto" === this.modal.heightType;
                },
                position: function() {
                    var window = this.window, shift = this.shift, pivotX = this.pivotX, pivotY = this.pivotY, trueModalWidth = this.trueModalWidth, trueModalHeight = this.trueModalHeight, containerElement = document.getElementById(this.container), containerWidth = containerElement ? containerElement.offsetWidth : window.width, containerHeight = containerElement ? containerElement.offsetHeight : window.height, maxLeft = containerWidth - trueModalWidth, maxTop = containerHeight - trueModalHeight, left = shift.left + pivotX * maxLeft, top = shift.top + pivotY * maxTop;
                    return {
                        left: (0, _util.inRange)(0, maxLeft, left),
                        top: (0, _util.inRange)(0, maxTop, top)
                    };
                },
                trueModalWidth: function() {
                    var window = this.window, modal = this.modal, adaptive = this.adaptive, minWidth = this.minWidth, maxWidth = this.maxWidth, value = "%" === modal.widthType ? window.width / 100 * modal.width : modal.width, max = Math.min(window.width, maxWidth);
                    return adaptive ? (0, _util.inRange)(minWidth, max, value) : value;
                },
                trueModalHeight: function() {
                    var window = this.window, modal = this.modal, isAutoHeight = this.isAutoHeight, adaptive = this.adaptive, maxHeight = this.maxHeight, value = "%" === modal.heightType ? window.height / 100 * modal.height : modal.height;
                    if (isAutoHeight) return this.modal.renderedHeight;
                    var max = Math.min(window.height, maxHeight);
                    return adaptive ? (0, _util.inRange)(this.minHeight, max, value) : value;
                },
                overlayClass: function() {
                    return {
                        "v--modal-overlay": !0,
                        scrollable: this.scrollable && this.isAutoHeight
                    };
                },
                modalClass: function() {
                    return [ "v--modal-box", this.classes ];
                },
                modalStyle: function() {
                    return {
                        top: this.position.top + "px",
                        left: this.position.left + "px",
                        width: this.trueModalWidth + "px",
                        height: this.isAutoHeight ? "auto" : this.trueModalHeight + "px"
                    };
                }
            },
            methods: {
                setInitialSize: function() {
                    var modal = this.modal, width = (0, _parser2.default)(this.width), height = (0, 
                    _parser2.default)(this.height);
                    modal.width = width.value, modal.widthType = width.type, modal.height = height.value, 
                    modal.heightType = height.type;
                },
                onEscapeKeyUp: function(event) {
                    27 === event.which && this.visible && this.$modal.hide(this.name);
                },
                onWindowResize: function() {
                    this.window.width = window.innerWidth, this.window.height = window.innerHeight;
                },
                genEventObject: function(params) {
                    var eventData = {
                        name: this.name,
                        timestamp: Date.now(),
                        canceled: !1,
                        ref: this.$refs.modal
                    };
                    return Object.assign(eventData, params || {});
                },
                onModalResizeBegin: function(event) {
                    this.shiftCache.left = event.position.left, this.shiftCache.top = event.position.top;
                },
                onModalResize: function(event) {
                    this.modal.width, this.modal.height;
                    this.modal.widthType = "px", this.modal.width = event.size.width, this.modal.heightType = "px", 
                    this.modal.height = event.size.height, this.shift.left = event.position.left, this.shift.top = event.position.top;
                    var _modal = this.modal, width = _modal.width, height = _modal.height, resizeEvent = this.genEventObject({
                        width: width,
                        height: height
                    });
                    this.$emit("resize", resizeEvent);
                },
                onModalResizeComplete: function(event) {
                    var cachedLeft = this.shiftCache.left, cachedTop = this.shiftCache.top, _shift = this.shift, left = _shift.left, top = _shift.top;
                    cachedLeft === left && cachedTop === top || this.emitDraggedEvent(), this.emitResizedEvent();
                },
                emitDraggedEvent: function() {
                    var _shift2 = this.shift, left = _shift2.left, top = _shift2.top, draggedEvent = this.genEventObject({
                        left: left,
                        top: top
                    });
                    this.$emit("dragged", draggedEvent);
                },
                emitResizedEvent: function() {
                    var _modal2 = this.modal, width = _modal2.width, height = _modal2.height, resizedEvent = this.genEventObject({
                        width: width,
                        height: height
                    });
                    this.$emit("resized", resizedEvent);
                },
                toggle: function(state, params) {
                    var reset = this.reset, scrollable = this.scrollable, visible = this.visible;
                    if (visible !== state) {
                        var beforeEventName = visible ? "before-close" : "before-open";
                        "before-open" === beforeEventName ? (document.activeElement && document.activeElement.blur(), 
                        reset && (this.setInitialSize(), this.shift.left = 0, this.shift.top = 0), scrollable && document.body.classList.add("v--modal-block-scroll")) : scrollable && document.body.classList.remove("v--modal-block-scroll");
                        var stopEventExecution = !1, stop = function() {
                            stopEventExecution = !0;
                        }, beforeEvent = this.genEventObject({
                            stop: stop,
                            state: state,
                            params: params
                        });
                        this.$emit(beforeEventName, beforeEvent), stopEventExecution || (this.visible = state);
                    }
                },
                getDraggableElement: function() {
                    var selector = "string" != typeof this.draggable ? ".v--modal-box" : this.draggable;
                    if (selector) {
                        var handler = this.$refs.overlay.querySelector(selector);
                        if (handler) return handler;
                    }
                },
                onBackgroundClick: function() {
                    this.clickToClose && this.toggle(!1);
                },
                addDraggableListeners: function() {
                    var _this3 = this;
                    if (this.draggable) {
                        var dragger = this.getDraggableElement();
                        if (dragger) {
                            var startX = 0, startY = 0, cachedShiftX = 0, cachedShiftY = 0, menuBarX = null, getPosition = function(event) {
                                return event.touches && event.touches.length > 0 ? event.touches[0] : event;
                            }, getContainerPosition = function(event) {
                                if (null === menuBarX) {
                                    var containerElement = document.getElementById(_this3.container);
                                    menuBarX = 0, null !== containerElement && (menuBarX = window.innerWidth - containerElement.getBoundingClientRect().width);
                                }
                                var _getPosition = getPosition(event), clientX = _getPosition.clientX, clientY = _getPosition.clientY;
                                return clientX -= menuBarX, {
                                    clientX: clientX,
                                    clientY: clientY
                                };
                            }, getGridStep = function() {
                                return _this3.autoSnapToGrid ? _this3.snapGridSize : 1;
                            }, mousedown = function(event) {
                                var target = event.target;
                                if (!target || "INPUT" !== target.nodeName) {
                                    var gridStep = getGridStep(), _getContainerPosition = getContainerPosition(event), clientX = _getContainerPosition.clientX, clientY = _getContainerPosition.clientY;
                                    clientX = Math.floor(clientX / gridStep) * gridStep, clientY = Math.floor(clientY / gridStep) * gridStep, 
                                    document.addEventListener("mousemove", _mousemove), document.addEventListener("mouseup", _mouseup), 
                                    document.addEventListener("touchmove", _mousemove), document.addEventListener("touchend", _mouseup), 
                                    startX = clientX, startY = clientY, cachedShiftX = _this3.shift.left, cachedShiftY = _this3.shift.top, 
                                    _this3.$emit("grabbed", !0);
                                }
                            }, _mousemove = function(event) {
                                var gridStep = getGridStep(), _getContainerPosition2 = getContainerPosition(event), clientX = _getContainerPosition2.clientX, clientY = _getContainerPosition2.clientY;
                                clientX = Math.floor(clientX / gridStep) * gridStep, clientY = Math.floor(clientY / gridStep) * gridStep, 
                                _this3.shift.left = cachedShiftX + (clientX - startX), _this3.shift.top = cachedShiftY + (clientY - startY);
                                var containerElement = document.getElementById(_this3.container), containerWidth = 0, containerHeight = 0;
                                null !== containerElement && (containerWidth = containerElement.getBoundingClientRect().width, 
                                containerHeight = containerElement.getBoundingClientRect().height), cachedShiftX + (clientX - startX) >= 0 ? _this3.shift.left = cachedShiftX + (clientX - startX) : (_this3.shift.left = 0, 
                                cachedShiftX = 0, startX = clientX, clientX < 0 && (startX = 0)), cachedShiftY + (clientY - startY) >= 0 ? _this3.shift.top = cachedShiftY + (clientY - startY) : (_this3.shift.top = 0, 
                                cachedShiftY = 0, startY = clientY, clientY < 0 && (startY = 0)), cachedShiftX + (clientX - startX) <= containerWidth - _this3.modal.width ? _this3.shift.left = cachedShiftX + (clientX - startX) : (_this3.shift.left = containerWidth - _this3.modal.width, 
                                cachedShiftX = containerWidth - _this3.modal.width, startX = clientX, clientX > containerWidth && (startX = containerWidth)), 
                                cachedShiftY + (clientY - startY) <= containerHeight - _this3.modal.height ? _this3.shift.top = cachedShiftY + (clientY - startY) : (_this3.shift.top = containerHeight - _this3.modal.height, 
                                cachedShiftY = containerHeight - _this3.modal.height, startY = clientY, clientY > containerHeight && (startY = containerHeight)), 
                                event.preventDefault();
                            }, _mouseup = function _mouseup(event) {
                                document.removeEventListener("mousemove", _mousemove), document.removeEventListener("mouseup", _mouseup), 
                                document.removeEventListener("touchmove", _mousemove), document.removeEventListener("touchend", _mouseup), 
                                event.preventDefault(), _this3.emitDraggedEvent(), _this3.$emit("grabbed", !1);
                            };
                            dragger.addEventListener("mousedown", mousedown), dragger.addEventListener("touchstart", mousedown);
                        }
                    }
                },
                removeDraggableListeners: function() {},
                callAfterEvent: function(state) {
                    state ? this.connectObserver() : this.disconnectObserver();
                    var eventName = state ? "opened" : "closed", event = this.genEventObject({
                        state: state
                    });
                    this.$emit(eventName, event);
                },
                updateRenderedHeight: function() {
                    this.$refs.modal && (this.modal.renderedHeight = this.$refs.modal.getBoundingClientRect().height);
                },
                connectObserver: function() {
                    this.mutationObserver && this.mutationObserver.observe(this.$refs.modal, {
                        childList: !0,
                        attributes: !0,
                        subtree: !0
                    });
                },
                disconnectObserver: function() {
                    this.mutationObserver && this.mutationObserver.disconnect();
                },
                moveTo: function(newPosition) {
                    newPosition && void 0 !== newPosition.left && (this.shift.left = newPosition.left), 
                    newPosition && void 0 !== newPosition.top && (this.shift.top = newPosition.top), 
                    this.emitDraggedEvent();
                },
                resize: function(newSize) {
                    newSize && newSize.width && (this.modal.width = newSize.width), newSize && newSize.height && (this.modal.height = newSize.height), 
                    this.emitResizedEvent();
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        __webpack_require__(14);
        var Component = __webpack_require__(2)(__webpack_require__(16), __webpack_require__(21), null, null);
        Component.options.__file = "C:\\www\\tombola-vue-js-modal\\src\\ResizerFrame.vue", 
        Component.esModule && Object.keys(Component.esModule).some(function(key) {
            return "default" !== key && "__esModule" !== key;
        }) && console.error("named exports are not supported in *.vue files."), Component.options.functional && console.error("[vue-loader] ResizerFrame.vue: functional components are not supported with templates, they should use render functions."), 
        exports.__esModule = !0, exports.default = Component.exports;
    }, function(module, exports, __webpack_require__) {
        var content = __webpack_require__(15);
        "string" == typeof content && (content = [ [ module.i, content, "" ] ]), content.locals && (module.exports = content.locals);
        __webpack_require__(1)("5eca7237", content, !1);
    }, function(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(0)(), exports.push([ module.i, "\n.vue-modal-resizer-frame {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  flex-flow: column;\n  position: relative;\n}\n.vue-modal-resizer-frame .vue-modal-resizer-frame-part {\n    display: flex;\n}\n.vue-modal-resizer-frame .vue-modal-resizer-frame-part.vue-modal-resizer-frame-part-center {\n      flex-basis: 100%;\n}\n.vue-modal-resizer-frame .vue-modal-resizer-frame-part.vue-modal-resizer-frame-part-center .vue-modal-resizer-frame-content {\n        flex-basis: 100%;\n        margin: -12px -12px;\n}\n", "", {
            version: 3,
            sources: [ "/./src/ResizerFrame.vue" ],
            names: [],
            mappings: ";AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,cAAc;CACjB;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,iBAAiB;QACjB,oBAAoB;CAC3B",
            file: "ResizerFrame.vue",
            sourcesContent: [ "\n.vue-modal-resizer-frame {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  flex-flow: column;\n  position: relative;\n}\n.vue-modal-resizer-frame .vue-modal-resizer-frame-part {\n    display: flex;\n}\n.vue-modal-resizer-frame .vue-modal-resizer-frame-part.vue-modal-resizer-frame-part-center {\n      flex-basis: 100%;\n}\n.vue-modal-resizer-frame .vue-modal-resizer-frame-part.vue-modal-resizer-frame-part-center .vue-modal-resizer-frame-content {\n        flex-basis: 100%;\n        margin: -12px -12px;\n}\n" ],
            sourceRoot: "webpack://"
        } ]);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _const = __webpack_require__(3), _Resizer = __webpack_require__(6), _Resizer2 = _interopRequireDefault(_Resizer), _parser = __webpack_require__(4);
        _interopRequireDefault(_parser);
        exports.default = {
            name: "VueJsModalResizerFrame",
            components: {
                Resizer: _Resizer2.default
            },
            props: {
                resizable: {
                    type: Boolean,
                    default: !0
                },
                minWidth: {
                    type: Number
                },
                minHeight: {
                    type: Number
                },
                container: {
                    type: String
                },
                snapGridSize: {
                    type: Number
                },
                autoSnapToGrid: {
                    type: Boolean
                }
            },
            computed: {
                isResizable: function() {
                    return this.resizable;
                }
            },
            data: function() {
                return {
                    SizingHandleType: _const.SizingHandleType
                };
            },
            methods: {
                onResize: function(event) {
                    this.$emit("resize", event);
                },
                onResizeBegin: function(event) {
                    this.$emit("resize-begin", event);
                },
                onResizeComplete: function(event) {
                    this.$emit("resized", event);
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        var content = __webpack_require__(18);
        "string" == typeof content && (content = [ [ module.i, content, "" ] ]), content.locals && (module.exports = content.locals);
        __webpack_require__(1)("50099078", content, !1);
    }, function(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(0)(), exports.push([ module.i, "\n.vue-modal-resizer {\n  display: block;\n  overflow: hidden;\n  position: relative;\n  z-index: 9999999;\n  background: transparent;\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n.vue-modal-resizer.vue-modal-resizer-tl, .vue-modal-resizer.vue-modal-resizer-br, .vue-modal-resizer.vue-modal-resizer-tr, .vue-modal-resizer.vue-modal-resizer-bl {\n    flex-grow: 0;\n    flex-shrink: 0;\n    width: 12px;\n    height: 12px;\n}\n.vue-modal-resizer.vue-modal-resizer-tl .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-br .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-tr .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-bl .vue-modal-resizer-grip:after {\n      opacity: 0;\n      transition: all 0.2s;\n}\n.vue-modal-resizer.vue-modal-resizer-tl:hover .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-br:hover .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-tr:hover .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-bl:hover .vue-modal-resizer-grip:after {\n      opacity: 0.4;\n}\n.vue-modal-resizer.vue-modal-resizer-tl.clicked .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-br.clicked .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-tr.clicked .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-bl.clicked .vue-modal-resizer-grip:after {\n      opacity: 1;\n}\n.vue-modal-resizer.vue-modal-resizer-tl, .vue-modal-resizer.vue-modal-resizer-br {\n    cursor: nwse-resize;\n}\n.vue-modal-resizer.vue-modal-resizer-tc, .vue-modal-resizer.vue-modal-resizer-bc {\n    cursor: ns-resize;\n    height: 12px;\n    flex-basis: 100%;\n}\n.vue-modal-resizer.vue-modal-resizer-tr, .vue-modal-resizer.vue-modal-resizer-bl {\n    cursor: nesw-resize;\n}\n.vue-modal-resizer.vue-modal-resizer-left, .vue-modal-resizer.vue-modal-resizer-right {\n    cursor: ew-resize;\n    flex-grow: 0;\n    flex-shrink: 0;\n    width: 12px;\n}\n.vue-modal-resizer .vue-modal-resizer-grip {\n    display: block;\n    position: relative;\n    height: 0;\n    width: 0;\n}\n.vue-modal-resizer .vue-modal-resizer-grip:after {\n      display: block;\n      position: absolute;\n      content: '';\n      background: transparent;\n      left: 0;\n      top: 0;\n      width: 0;\n      height: 0;\n}\n.vue-modal-resizer.vue-modal-resizer-tl .vue-modal-resizer-grip:after {\n    border-top: 12px solid #ddd;\n    border-right: 12px solid transparent;\n}\n.vue-modal-resizer.vue-modal-resizer-tl.clicked .vue-modal-resizer-grip:after {\n    border-top-color: #369be9;\n}\n.vue-modal-resizer.vue-modal-resizer-tr .vue-modal-resizer-grip:after {\n    border-top: 12px solid #ddd;\n    border-left: 12px solid transparent;\n}\n.vue-modal-resizer.vue-modal-resizer-tr.clicked .vue-modal-resizer-grip:after {\n    border-top-color: #369be9;\n}\n.vue-modal-resizer.vue-modal-resizer-bl .vue-modal-resizer-grip:after {\n    border-bottom: 12px solid #ddd;\n    border-right: 12px solid transparent;\n}\n.vue-modal-resizer.vue-modal-resizer-bl.clicked .vue-modal-resizer-grip:after {\n    border-bottom-color: #369be9;\n}\n.vue-modal-resizer.vue-modal-resizer-br .vue-modal-resizer-grip:after {\n    border-bottom: 12px solid #ddd;\n    border-left: 12px solid transparent;\n    opacity: 1;\n}\n.vue-modal-resizer.vue-modal-resizer-br:hover .vue-modal-resizer-grip:after {\n    opacity: 1;\n}\n.vue-modal-resizer.vue-modal-resizer-br.clicked .vue-modal-resizer-grip:after {\n    border-bottom: 12px solid #369be9;\n}\n.vue-modal-resizer.vue-modal-resizer-tc .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-left .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right .vue-modal-resizer-grip {\n    opacity: 0;\n    background-color: #ddd;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 4px;\n    transition: all 0.2s;\n}\n.vue-modal-resizer.vue-modal-resizer-tc:hover .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc:hover .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-left:hover .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right:hover .vue-modal-resizer-grip {\n    opacity: 0.4;\n}\n.vue-modal-resizer.vue-modal-resizer-tc.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-left.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right.clicked .vue-modal-resizer-grip {\n    background-color: #369be9;\n    opacity: 1;\n}\n.vue-modal-resizer.vue-modal-resizer-tc .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc .vue-modal-resizer-grip {\n    height: 4px;\n    width: 50%;\n}\n.vue-modal-resizer.vue-modal-resizer-tc.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc.clicked .vue-modal-resizer-grip {\n    transform: translate(-50%, -50%) scaleX(1.1);\n}\n.vue-modal-resizer.vue-modal-resizer-left .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right .vue-modal-resizer-grip {\n    width: 4px;\n    height: 50%;\n}\n.vue-modal-resizer.vue-modal-resizer-left.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right.clicked .vue-modal-resizer-grip {\n    transform: translate(-50%, -50%) scaleY(1.1);\n}\n", "", {
            version: 3,
            sources: [ "/./src/Resizer.vue" ],
            names: [],
            mappings: ";AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,UAAU;EACV,WAAW;CACZ;AACD;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,aAAa;CAChB;AACD;MACM,WAAW;MACX,qBAAqB;CAC1B;AACD;MACM,aAAa;CAClB;AACD;MACM,WAAW;CAChB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,YAAY;CACf;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,SAAS;CACZ;AACD;MACM,eAAe;MACf,mBAAmB;MACnB,YAAY;MACZ,wBAAwB;MACxB,QAAQ;MACR,OAAO;MACP,SAAS;MACT,UAAU;CACf;AACD;IACI,4BAA4B;IAC5B,qCAAqC;CACxC;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,4BAA4B;IAC5B,oCAAoC;CACvC;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,+BAA+B;IAC/B,qCAAqC;CACxC;AACD;IACI,6BAA6B;CAChC;AACD;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,WAAW;CACd;AACD;IACI,WAAW;CACd;AACD;IACI,kCAAkC;CACrC;AACD;IACI,WAAW;IACX,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,iCAAiC;IACjC,mBAAmB;IACnB,qBAAqB;CACxB;AACD;IACI,aAAa;CAChB;AACD;IACI,0BAA0B;IAC1B,WAAW;CACd;AACD;IACI,YAAY;IACZ,WAAW;CACd;AACD;IACI,6CAA6C;CAChD;AACD;IACI,WAAW;IACX,YAAY;CACf;AACD;IACI,6CAA6C;CAChD",
            file: "Resizer.vue",
            sourcesContent: [ "\n.vue-modal-resizer {\n  display: block;\n  overflow: hidden;\n  position: relative;\n  z-index: 9999999;\n  background: transparent;\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n.vue-modal-resizer.vue-modal-resizer-tl, .vue-modal-resizer.vue-modal-resizer-br, .vue-modal-resizer.vue-modal-resizer-tr, .vue-modal-resizer.vue-modal-resizer-bl {\n    flex-grow: 0;\n    flex-shrink: 0;\n    width: 12px;\n    height: 12px;\n}\n.vue-modal-resizer.vue-modal-resizer-tl .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-br .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-tr .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-bl .vue-modal-resizer-grip:after {\n      opacity: 0;\n      transition: all 0.2s;\n}\n.vue-modal-resizer.vue-modal-resizer-tl:hover .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-br:hover .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-tr:hover .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-bl:hover .vue-modal-resizer-grip:after {\n      opacity: 0.4;\n}\n.vue-modal-resizer.vue-modal-resizer-tl.clicked .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-br.clicked .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-tr.clicked .vue-modal-resizer-grip:after, .vue-modal-resizer.vue-modal-resizer-bl.clicked .vue-modal-resizer-grip:after {\n      opacity: 1;\n}\n.vue-modal-resizer.vue-modal-resizer-tl, .vue-modal-resizer.vue-modal-resizer-br {\n    cursor: nwse-resize;\n}\n.vue-modal-resizer.vue-modal-resizer-tc, .vue-modal-resizer.vue-modal-resizer-bc {\n    cursor: ns-resize;\n    height: 12px;\n    flex-basis: 100%;\n}\n.vue-modal-resizer.vue-modal-resizer-tr, .vue-modal-resizer.vue-modal-resizer-bl {\n    cursor: nesw-resize;\n}\n.vue-modal-resizer.vue-modal-resizer-left, .vue-modal-resizer.vue-modal-resizer-right {\n    cursor: ew-resize;\n    flex-grow: 0;\n    flex-shrink: 0;\n    width: 12px;\n}\n.vue-modal-resizer .vue-modal-resizer-grip {\n    display: block;\n    position: relative;\n    height: 0;\n    width: 0;\n}\n.vue-modal-resizer .vue-modal-resizer-grip:after {\n      display: block;\n      position: absolute;\n      content: '';\n      background: transparent;\n      left: 0;\n      top: 0;\n      width: 0;\n      height: 0;\n}\n.vue-modal-resizer.vue-modal-resizer-tl .vue-modal-resizer-grip:after {\n    border-top: 12px solid #ddd;\n    border-right: 12px solid transparent;\n}\n.vue-modal-resizer.vue-modal-resizer-tl.clicked .vue-modal-resizer-grip:after {\n    border-top-color: #369be9;\n}\n.vue-modal-resizer.vue-modal-resizer-tr .vue-modal-resizer-grip:after {\n    border-top: 12px solid #ddd;\n    border-left: 12px solid transparent;\n}\n.vue-modal-resizer.vue-modal-resizer-tr.clicked .vue-modal-resizer-grip:after {\n    border-top-color: #369be9;\n}\n.vue-modal-resizer.vue-modal-resizer-bl .vue-modal-resizer-grip:after {\n    border-bottom: 12px solid #ddd;\n    border-right: 12px solid transparent;\n}\n.vue-modal-resizer.vue-modal-resizer-bl.clicked .vue-modal-resizer-grip:after {\n    border-bottom-color: #369be9;\n}\n.vue-modal-resizer.vue-modal-resizer-br .vue-modal-resizer-grip:after {\n    border-bottom: 12px solid #ddd;\n    border-left: 12px solid transparent;\n    opacity: 1;\n}\n.vue-modal-resizer.vue-modal-resizer-br:hover .vue-modal-resizer-grip:after {\n    opacity: 1;\n}\n.vue-modal-resizer.vue-modal-resizer-br.clicked .vue-modal-resizer-grip:after {\n    border-bottom: 12px solid #369be9;\n}\n.vue-modal-resizer.vue-modal-resizer-tc .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-left .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right .vue-modal-resizer-grip {\n    opacity: 0;\n    background-color: #ddd;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 4px;\n    transition: all 0.2s;\n}\n.vue-modal-resizer.vue-modal-resizer-tc:hover .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc:hover .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-left:hover .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right:hover .vue-modal-resizer-grip {\n    opacity: 0.4;\n}\n.vue-modal-resizer.vue-modal-resizer-tc.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-left.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right.clicked .vue-modal-resizer-grip {\n    background-color: #369be9;\n    opacity: 1;\n}\n.vue-modal-resizer.vue-modal-resizer-tc .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc .vue-modal-resizer-grip {\n    height: 4px;\n    width: 50%;\n}\n.vue-modal-resizer.vue-modal-resizer-tc.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-bc.clicked .vue-modal-resizer-grip {\n    transform: translate(-50%, -50%) scaleX(1.1);\n}\n.vue-modal-resizer.vue-modal-resizer-left .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right .vue-modal-resizer-grip {\n    width: 4px;\n    height: 50%;\n}\n.vue-modal-resizer.vue-modal-resizer-left.clicked .vue-modal-resizer-grip, .vue-modal-resizer.vue-modal-resizer-right.clicked .vue-modal-resizer-grip {\n    transform: translate(-50%, -50%) scaleY(1.1);\n}\n" ],
            sourceRoot: "webpack://"
        } ]);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _util = __webpack_require__(7), _const = __webpack_require__(3);
        exports.default = {
            name: "VueJsModalResizer",
            props: {
                type: {
                    type: String,
                    validator: function(value) {
                        return Object.keys(_const.SizingHandleType).indexOf(value) >= 0;
                    }
                },
                minHeight: {
                    type: Number,
                    default: 200
                },
                minWidth: {
                    type: Number,
                    default: 100
                },
                maxWidth: {
                    type: Number,
                    default: 1 / 0
                },
                container: {
                    type: String
                },
                visible: {
                    type: Boolean,
                    default: !0
                },
                snapGridSize: {
                    type: Number
                },
                autoSnapToGrid: {
                    type: Boolean
                }
            },
            data: function() {
                return {
                    clicked: !1,
                    position: {},
                    size: {}
                };
            },
            mounted: function() {
                this.$el.addEventListener("mousedown", this.start, !1);
            },
            computed: {
                className: function() {
                    var typeCssClass = (0, _const.getCssClassForSizingHandleType)(this.type), result = {
                        "vue-modal-resizer": !0,
                        clicked: this.clicked
                    };
                    return result[typeCssClass] = !0, result;
                }
            },
            methods: {
                start: function(event) {
                    this.clicked = !0, window.addEventListener("mousemove", this.mousemove, !1), window.addEventListener("mouseup", this.stop, !1), 
                    event.stopPropagation(), event.preventDefault(), this.$emit("resize-start", {
                        element: this.$el.parentElement,
                        sizingHandle: this.type,
                        position: this.position,
                        size: this.size
                    });
                },
                stop: function() {
                    this.clicked = !1, window.removeEventListener("mousemove", this.mousemove, !1), 
                    window.removeEventListener("mouseup", this.stop, !1), this.$emit("resize-stop", {
                        element: this.$el.parentElement,
                        sizingHandle: this.type,
                        position: this.position,
                        size: this.size
                    });
                },
                mousemove: function(event) {
                    this.resize(event);
                },
                resize: function(event) {
                    var el = this.$el.closest(".v--modal-box");
                    if (el) {
                        var elIsPanelResizer = el.classList.contains("vue-panel-resizer-lhs"), containerElement = document.getElementById(this.container), containerBoundingRect = containerElement ? containerElement.getBoundingClientRect() : null, elBoundingRect = el.getBoundingClientRect(), containerLeft = containerBoundingRect ? containerBoundingRect.x : elIsPanelResizer ? elBoundingRect.left : 0, containerTop = containerBoundingRect ? containerBoundingRect.y : elIsPanelResizer ? elBoundingRect.top : 0, containerWidth = containerElement ? containerElement.offsetWidth : window.innerWidth, containerHeight = containerElement ? containerElement.offsetHeight : window.innerHeight, clientX = event.clientX - containerLeft, clientY = event.clientY - containerTop, gridStep = this.autoSnapToGrid ? this.snapGridSize : 1, elLeft = el.offsetLeft, elTop = el.offsetTop, elRight = elLeft + el.offsetWidth, elBottom = elTop + el.offsetHeight;
                        switch (this.type) {
                          case _const.SizingHandleType.TopLeft:
                            elLeft = clientX - 6, elTop = clientY - 6, elRight - elLeft < this.minWidth && (elLeft = elRight - this.minWidth), 
                            elRight - elLeft > this.maxWidth && (elLeft = elRight - this.maxWidth), elBottom - elTop < this.minHeight && (elTop = elBottom - this.minHeight), 
                            elLeft = Math.floor(elLeft / gridStep) * gridStep, elTop = Math.floor(elTop / gridStep) * gridStep, 
                            elLeft = Math.max(0, elLeft), elTop = Math.max(0, elTop);
                            break;

                          case _const.SizingHandleType.Top:
                            elTop = clientY - 6, elBottom - elTop < this.minHeight && (elTop = elBottom - this.minHeight), 
                            elTop = Math.floor(elTop / gridStep) * gridStep, elTop = Math.max(0, elTop);
                            break;

                          case _const.SizingHandleType.TopRight:
                            elRight = clientX + 6, elTop = clientY - 6, elRight - elLeft > this.maxWidth && (elRight = elLeft + this.maxWidth), 
                            elBottom - elTop < this.minHeight && (elTop = elBottom - this.minHeight), elRight = Math.ceil(elRight / gridStep) * gridStep, 
                            elTop = Math.floor(elTop / gridStep) * gridStep, elTop = Math.max(0, elTop);
                            break;

                          case _const.SizingHandleType.Left:
                            elLeft = clientX - 6, elRight - elLeft < this.minWidth && (elLeft = elRight - this.minWidth), 
                            elRight - elLeft > this.maxWidth && (elLeft = elRight - this.maxWidth), elLeft = Math.floor(elLeft / gridStep) * gridStep, 
                            elLeft = Math.max(0, elLeft);
                            break;

                          case _const.SizingHandleType.Right:
                            elRight = clientX + 6, elRight - elLeft > this.maxWidth && (elRight = elLeft + this.maxWidth), 
                            elRight = Math.ceil(elRight / gridStep) * gridStep;
                            break;

                          case _const.SizingHandleType.BottomLeft:
                            elLeft = clientX - 6, elBottom = clientY + 6, elRight - elLeft < this.minWidth && (elLeft = elRight - this.minWidth), 
                            elRight - elLeft > this.maxWidth && (elLeft = elRight - this.maxWidth), elLeft = Math.floor(elLeft / gridStep) * gridStep, 
                            elBottom = Math.ceil(elBottom / gridStep) * gridStep, elLeft = Math.max(0, elLeft);
                            break;

                          case _const.SizingHandleType.Bottom:
                            elBottom = clientY + 6, elBottom = Math.ceil(elBottom / gridStep) * gridStep;
                            break;

                          case _const.SizingHandleType.BottomRight:
                            elRight = clientX + 6, elBottom = clientY + 6, elRight - elLeft > this.maxWidth && (elRight = elLeft + this.maxWidth), 
                            elRight = Math.ceil(elRight / gridStep) * gridStep, elBottom = Math.ceil(elBottom / gridStep) * gridStep;
                        }
                        containerWidth -= elLeft, containerHeight -= elTop;
                        var width = (0, _util.inRange)(this.minWidth, containerWidth, elRight - elLeft), height = (0, 
                        _util.inRange)(this.minHeight, containerHeight, elBottom - elTop);
                        this.position = {
                            left: elLeft,
                            top: elTop
                        }, this.size = {
                            width: width,
                            height: height
                        }, el.style.top = elTop + "px", el.style.left = elLeft + "px", el.style.width = width + "px", 
                        elIsPanelResizer || (el.style.height = height + "px"), this.$emit("resize", {
                            element: el,
                            sizingHandle: this.type,
                            position: this.position,
                            size: this.size
                        });
                    }
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        module.exports = {
            render: function() {
                var _vm = this, _h = _vm.$createElement, _c = _vm._self._c || _h;
                return _c("div", {
                    directives: [ {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.visible,
                        expression: "visible"
                    } ],
                    class: _vm.className
                }, [ _c("div", {
                    staticClass: "vue-modal-resizer-grip"
                }) ]);
            },
            staticRenderFns: []
        }, module.exports.render._withStripped = !0;
    }, function(module, exports, __webpack_require__) {
        module.exports = {
            render: function() {
                var _vm = this, _h = _vm.$createElement, _c = _vm._self._c || _h;
                return _c("div", {
                    staticClass: "vue-modal-resizer-frame"
                }, [ _c("div", {
                    staticClass: "vue-modal-resizer-frame-part vue-modal-resizer-frame-part-top"
                }, [ _c("resizer", {
                    attrs: {
                        visible: _vm.isResizable,
                        "min-width": _vm.minWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.TopLeft
                    },
                    on: {
                        resize: _vm.onResize,
                        "resize-start": _vm.onResizeBegin,
                        "resize-stop": _vm.onResizeComplete
                    }
                }), _vm._v(" "), _c("resizer", {
                    attrs: {
                        visible: _vm.isResizable,
                        "min-width": _vm.minWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.Top
                    },
                    on: {
                        resize: _vm.onResize,
                        "resize-start": _vm.onResizeBegin,
                        "resize-stop": _vm.onResizeComplete
                    }
                }), _vm._v(" "), _c("resizer", {
                    attrs: {
                        visible: _vm.isResizable,
                        "min-width": _vm.minWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.TopRight
                    },
                    on: {
                        resize: _vm.onResize,
                        "resize-start": _vm.onResizeBegin,
                        "resize-stop": _vm.onResizeComplete
                    }
                }) ], 1), _vm._v(" "), _c("div", {
                    staticClass: "vue-modal-resizer-frame-part vue-modal-resizer-frame-part-center"
                }, [ _c("resizer", {
                    attrs: {
                        visible: _vm.isResizable,
                        "min-width": _vm.minWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.Left
                    },
                    on: {
                        resize: _vm.onResize,
                        "resize-start": _vm.onResizeBegin,
                        "resize-stop": _vm.onResizeComplete
                    }
                }), _vm._v(" "), _c("div", {
                    staticClass: "vue-modal-resizer-frame-content"
                }, [ _vm._t("default") ], 2), _vm._v(" "), _c("resizer", {
                    attrs: {
                        visible: _vm.isResizable,
                        "min-width": _vm.minWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.Right
                    },
                    on: {
                        resize: _vm.onResize,
                        "resize-start": _vm.onResizeBegin,
                        "resize-stop": _vm.onResizeComplete
                    }
                }) ], 1), _vm._v(" "), _c("div", {
                    staticClass: "vue-modal-resizer-frame-part vue-modal-resizer-frame-part-bottom"
                }, [ _c("resizer", {
                    attrs: {
                        visible: _vm.isResizable,
                        "min-width": _vm.minWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.BottomLeft
                    },
                    on: {
                        resize: _vm.onResize,
                        "resize-start": _vm.onResizeBegin,
                        "resize-stop": _vm.onResizeComplete
                    }
                }), _vm._v(" "), _c("resizer", {
                    attrs: {
                        visible: _vm.isResizable,
                        "min-width": _vm.minWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.Bottom
                    },
                    on: {
                        resize: _vm.onResize,
                        "resize-start": _vm.onResizeBegin,
                        "resize-stop": _vm.onResizeComplete
                    }
                }), _vm._v(" "), _c("resizer", {
                    attrs: {
                        visible: _vm.isResizable,
                        "min-width": _vm.minWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.BottomRight
                    },
                    on: {
                        resize: _vm.onResize,
                        "resize-start": _vm.onResizeBegin,
                        "resize-stop": _vm.onResizeComplete
                    }
                }) ], 1) ]);
            },
            staticRenderFns: []
        }, module.exports.render._withStripped = !0;
    }, function(module, exports, __webpack_require__) {
        module.exports = {
            render: function() {
                var _vm = this, _h = _vm.$createElement, _c = _vm._self._c || _h;
                return _c("transition", {
                    attrs: {
                        name: "overlay-fade"
                    }
                }, [ _vm.visibility.overlay ? _c("div", {
                    ref: "overlay",
                    class: _vm.overlayClass,
                    attrs: {
                        "aria-expanded": _vm.visible.toString(),
                        "data-modal": _vm.name
                    },
                    on: {
                        mousedown: function($event) {
                            return $event.stopPropagation(), _vm.onBackgroundClick($event);
                        },
                        touchstart: function($event) {
                            return $event.stopPropagation(), _vm.onBackgroundClick($event);
                        }
                    }
                }, [ _c("div", {
                    staticClass: "v--modal-top-right"
                }, [ _vm._t("top-right") ], 2), _vm._v(" "), _c("transition", {
                    attrs: {
                        name: _vm.transition
                    }
                }, [ _vm.visibility.modal ? _c("div", {
                    ref: "modal",
                    class: _vm.modalClass,
                    style: _vm.modalStyle,
                    on: {
                        mousedown: function($event) {
                            $event.stopPropagation();
                        },
                        touchstart: function($event) {
                            $event.stopPropagation();
                        }
                    }
                }, [ _c("resizer-frame", {
                    attrs: {
                        resizable: _vm.resizable,
                        minWidth: _vm.minWidth,
                        minHeight: _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid
                    },
                    on: {
                        "resize-begin": _vm.onModalResizeBegin,
                        resize: _vm.onModalResize,
                        resized: _vm.onModalResizeComplete
                    }
                }, [ _vm._t("default") ], 2) ], 1) : _vm._e() ]) ], 1) : _vm._e() ]);
            },
            staticRenderFns: []
        }, module.exports.render._withStripped = !0;
    }, function(module, exports, __webpack_require__) {
        __webpack_require__(24);
        var Component = __webpack_require__(2)(__webpack_require__(26), __webpack_require__(27), null, null);
        Component.options.__file = "C:\\www\\tombola-vue-js-modal\\src\\Dialog.vue", Component.esModule && Object.keys(Component.esModule).some(function(key) {
            return "default" !== key && "__esModule" !== key;
        }) && console.error("named exports are not supported in *.vue files."), Component.options.functional && console.error("[vue-loader] Dialog.vue: functional components are not supported with templates, they should use render functions."), 
        exports.__esModule = !0, exports.default = Component.exports;
    }, function(module, exports, __webpack_require__) {
        var content = __webpack_require__(25);
        "string" == typeof content && (content = [ [ module.i, content, "" ] ]), content.locals && (module.exports = content.locals);
        __webpack_require__(1)("649a2244", content, !1);
    }, function(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(0)(), exports.push([ module.i, "\n.vue-dialog div {\r\n  box-sizing: border-box;\n}\n.vue-dialog .dialog-flex {\r\n  width: 100%;\r\n  height: 100%;\n}\n.vue-dialog .dialog-content {\r\n  flex: 1 0 auto;\r\n  width: 100%;\r\n  padding: 15px;\r\n  font-size: 14px;\n}\n.vue-dialog .dialog-c-title {\r\n  font-weight: 600;\r\n  padding-bottom: 15px;\n}\n.vue-dialog .dialog-c-text {\n}\n.vue-dialog .vue-dialog-buttons {\r\n  display: flex;\r\n  flex: 0 1 auto;\r\n  width: 100%;\r\n  border-top: 1px solid #eee;\n}\n.vue-dialog .vue-dialog-buttons-none {\r\n  width: 100%;\r\n  padding-bottom: 15px;\n}\n.vue-dialog-button {\r\n  font-size: 12px !important;\r\n  background: transparent;\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n  cursor: pointer;\r\n  box-sizing: border-box;\r\n  line-height: 40px;\r\n  height: 40px;\r\n  color: inherit;\r\n  font: inherit;\r\n  outline: none;\n}\n.vue-dialog-button:hover {\r\n  background: rgba(0, 0, 0, 0.01);\n}\n.vue-dialog-button:active {\r\n  background: rgba(0, 0, 0, 0.025);\n}\n.vue-dialog-button:not(:first-of-type) {\r\n  border-left: 1px solid #eee;\n}\r\n", "", {
            version: 3,
            sources: [ "/./src/Dialog.vue" ],
            names: [],
            mappings: ";AACA;EACE,uBAAuB;CACxB;AACD;EACE,YAAY;EACZ,aAAa;CACd;AACD;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;CACjB;AACD;EACE,iBAAiB;EACjB,qBAAqB;CACtB;AACD;CACC;AACD;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,2BAA2B;CAC5B;AACD;EACE,YAAY;EACZ,qBAAqB;CACtB;AACD;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,WAAW;EACX,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,cAAc;CACf;AACD;EACE,gCAAgC;CACjC;AACD;EACE,iCAAiC;CAClC;AACD;EACE,4BAA4B;CAC7B",
            file: "Dialog.vue",
            sourcesContent: [ "\n.vue-dialog div {\r\n  box-sizing: border-box;\n}\n.vue-dialog .dialog-flex {\r\n  width: 100%;\r\n  height: 100%;\n}\n.vue-dialog .dialog-content {\r\n  flex: 1 0 auto;\r\n  width: 100%;\r\n  padding: 15px;\r\n  font-size: 14px;\n}\n.vue-dialog .dialog-c-title {\r\n  font-weight: 600;\r\n  padding-bottom: 15px;\n}\n.vue-dialog .dialog-c-text {\n}\n.vue-dialog .vue-dialog-buttons {\r\n  display: flex;\r\n  flex: 0 1 auto;\r\n  width: 100%;\r\n  border-top: 1px solid #eee;\n}\n.vue-dialog .vue-dialog-buttons-none {\r\n  width: 100%;\r\n  padding-bottom: 15px;\n}\n.vue-dialog-button {\r\n  font-size: 12px !important;\r\n  background: transparent;\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n  cursor: pointer;\r\n  box-sizing: border-box;\r\n  line-height: 40px;\r\n  height: 40px;\r\n  color: inherit;\r\n  font: inherit;\r\n  outline: none;\n}\n.vue-dialog-button:hover {\r\n  background: rgba(0, 0, 0, 0.01);\n}\n.vue-dialog-button:active {\r\n  background: rgba(0, 0, 0, 0.025);\n}\n.vue-dialog-button:not(:first-of-type) {\r\n  border-left: 1px solid #eee;\n}\r\n" ],
            sourceRoot: "webpack://"
        } ]);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.default = {
            name: "Dialog",
            props: {
                width: {
                    type: [ Number, String ],
                    default: 400
                },
                clickToClose: {
                    type: Boolean,
                    default: !0
                },
                transition: {
                    type: String,
                    default: "fade"
                }
            },
            data: function() {
                return {
                    params: {},
                    defaultButtons: [ {
                        title: "CLOSE"
                    } ]
                };
            },
            computed: {
                buttons: function() {
                    return this.params.buttons || this.defaultButtons;
                },
                buttonStyle: function() {
                    return {
                        flex: "1 1 " + 100 / this.buttons.length + "%"
                    };
                }
            },
            methods: {
                beforeOpened: function(event) {
                    window.addEventListener("keyup", this.onKeyUp), this.params = event.params || {}, 
                    this.$emit("before-opened", event);
                },
                beforeClosed: function(event) {
                    window.removeEventListener("keyup", this.onKeyUp), this.params = {}, this.$emit("before-closed", event);
                },
                click: function(i, event) {
                    var source = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "click", button = this.buttons[i];
                    button && "function" == typeof button.handler ? button.handler(i, event, {
                        source: source
                    }) : this.$modal.hide("dialog");
                },
                onKeyUp: function(event) {
                    if (13 === event.which && this.buttons.length > 0) {
                        var buttonIndex = 1 === this.buttons.length ? 0 : this.buttons.findIndex(function(button) {
                            return button.default;
                        });
                        -1 !== buttonIndex && this.click(buttonIndex, event, "keypress");
                    }
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        module.exports = {
            render: function() {
                var _vm = this, _h = _vm.$createElement, _c = _vm._self._c || _h;
                return _c("modal", {
                    attrs: {
                        name: "dialog",
                        height: "auto",
                        classes: [ "v--modal", "vue-dialog", this.params.class ],
                        width: _vm.width,
                        "pivot-y": .3,
                        adaptive: !0,
                        clickToClose: _vm.clickToClose,
                        transition: _vm.transition
                    },
                    on: {
                        "before-open": _vm.beforeOpened,
                        "before-close": _vm.beforeClosed,
                        opened: function($event) {
                            _vm.$emit("opened", $event);
                        },
                        closed: function($event) {
                            _vm.$emit("closed", $event);
                        }
                    }
                }, [ _c("div", {
                    staticClass: "dialog-content"
                }, [ _vm.params.title ? _c("div", {
                    staticClass: "dialog-c-title",
                    domProps: {
                        innerHTML: _vm._s(_vm.params.title || "")
                    }
                }) : _vm._e(), _vm._v(" "), _c("div", {
                    staticClass: "dialog-c-text",
                    domProps: {
                        innerHTML: _vm._s(_vm.params.text || "")
                    }
                }) ]), _vm._v(" "), _vm.buttons ? _c("div", {
                    staticClass: "vue-dialog-buttons"
                }, _vm._l(_vm.buttons, function(button, i) {
                    return _c("button", {
                        key: i,
                        class: button.class || "vue-dialog-button",
                        style: _vm.buttonStyle,
                        domProps: {
                            innerHTML: _vm._s(button.title)
                        },
                        on: {
                            click: function($event) {
                                $event.stopPropagation(), _vm.click(i, $event);
                            }
                        }
                    }, [ _vm._v("\n      " + _vm._s(button.title) + "\n    ") ]);
                })) : _c("div", {
                    staticClass: "vue-dialog-buttons-none"
                }) ]);
            },
            staticRenderFns: []
        }, module.exports.render._withStripped = !0;
    }, function(module, exports, __webpack_require__) {
        __webpack_require__(29);
        var Component = __webpack_require__(2)(__webpack_require__(31), __webpack_require__(37), null, null);
        Component.options.__file = "C:\\www\\tombola-vue-js-modal\\src\\PanelResizer.vue", 
        Component.esModule && Object.keys(Component.esModule).some(function(key) {
            return "default" !== key && "__esModule" !== key;
        }) && console.error("named exports are not supported in *.vue files."), Component.options.functional && console.error("[vue-loader] PanelResizer.vue: functional components are not supported with templates, they should use render functions."), 
        exports.__esModule = !0, exports.default = Component.exports;
    }, function(module, exports, __webpack_require__) {
        var content = __webpack_require__(30);
        "string" == typeof content && (content = [ [ module.i, content, "" ] ]), content.locals && (module.exports = content.locals);
        __webpack_require__(1)("d868e1fe", content, !1);
    }, function(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(0)(), exports.push([ module.i, "\n.vue-panel-resizer {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  align-items: stretch;\n}\n.vue-panel-resizer:after {\n    display: block;\n    content: '';\n    clear: both;\n}\n.vue-panel-resizer .vue-panel-resizer-rhs {\n    position: relative;\n    flex: 1 1 auto;\n}\n.vue-panel-resizer .vue-panel-resizer-lhs {\n    position: relative;\n    float: left;\n    flex: 0 0 auto;\n}\n.vue-panel-resizer .vue-panel-resizer-lhs .vue-modal-resizer.vue-modal-resizer-right {\n      z-index: 998;\n}\n.vue-panel-resizer .vue-panel-resizer-lhs .vue-modal-resizer.vue-modal-resizer-right .vue-modal-resizer-grip {\n        height: 85%;\n        opacity: 0.4;\n}\n.vue-panel-resizer .vue-panel-resizer-lhs .vue-modal-resizer.vue-modal-resizer-right.clicked .vue-modal-resizer-grip {\n        opacity: 1;\n}\n", "", {
            version: 3,
            sources: [ "/./src/PanelResizer.vue" ],
            names: [],
            mappings: ";AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;CACtB;AACD;IACI,eAAe;IACf,YAAY;IACZ,YAAY;CACf;AACD;IACI,mBAAmB;IACnB,eAAe;CAClB;AACD;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;CAClB;AACD;MACM,aAAa;CAClB;AACD;QACQ,YAAY;QACZ,aAAa;CACpB;AACD;QACQ,WAAW;CAClB",
            file: "PanelResizer.vue",
            sourcesContent: [ "\n.vue-panel-resizer {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  align-items: stretch;\n}\n.vue-panel-resizer:after {\n    display: block;\n    content: '';\n    clear: both;\n}\n.vue-panel-resizer .vue-panel-resizer-rhs {\n    position: relative;\n    flex: 1 1 auto;\n}\n.vue-panel-resizer .vue-panel-resizer-lhs {\n    position: relative;\n    float: left;\n    flex: 0 0 auto;\n}\n.vue-panel-resizer .vue-panel-resizer-lhs .vue-modal-resizer.vue-modal-resizer-right {\n      z-index: 998;\n}\n.vue-panel-resizer .vue-panel-resizer-lhs .vue-modal-resizer.vue-modal-resizer-right .vue-modal-resizer-grip {\n        height: 85%;\n        opacity: 0.4;\n}\n.vue-panel-resizer .vue-panel-resizer-lhs .vue-modal-resizer.vue-modal-resizer-right.clicked .vue-modal-resizer-grip {\n        opacity: 1;\n}\n" ],
            sourceRoot: "webpack://"
        } ]);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _const = __webpack_require__(3), _PanelResizerFrame = __webpack_require__(32), _PanelResizerFrame2 = _interopRequireDefault(_PanelResizerFrame), _parser = __webpack_require__(4), _parser2 = _interopRequireDefault(_parser);
        exports.default = {
            name: "VueJsModalResizer",
            components: {
                PanelResizerFrame: _PanelResizerFrame2.default
            },
            props: {
                minWidth: {
                    type: Number,
                    default: 100
                },
                maxWidth: {
                    type: Number,
                    default: 1 / 0
                },
                width: {
                    type: [ Number, String ],
                    validator: function(value) {
                        if ("string" == typeof value) {
                            var width = (0, _parser2.default)(value);
                            return ("%" === width.type || "px" === width.type) && width.value > 0;
                        }
                        return value >= 0;
                    }
                },
                container: {
                    type: String
                },
                lhsVisible: {
                    type: Boolean,
                    default: !0
                },
                snapGridSize: {
                    type: Number,
                    default: 4,
                    validator: function(value) {
                        return value > 0;
                    }
                },
                autoSnapToGrid: {
                    type: Boolean,
                    default: !1
                }
            },
            data: function() {
                return {
                    SizingHandleType: _const.SizingHandleType,
                    internalWidth: null
                };
            },
            computed: {
                lhsWidth: function() {
                    if (this.internalWidth) return this.internalWidth + "px";
                    if ("string" == typeof this.width) {
                        var width = (0, _parser2.default)(this.width);
                        return "" + width.value + width.type;
                    }
                    return "auto";
                },
                lhsStyle: function() {
                    return {
                        width: this.lhsWidth
                    };
                }
            },
            methods: {
                onResize: function(event) {
                    this.internalWidth = event.size.width, this.$emit("resize");
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        __webpack_require__(33);
        var Component = __webpack_require__(2)(__webpack_require__(35), __webpack_require__(36), null, null);
        Component.options.__file = "C:\\www\\tombola-vue-js-modal\\src\\PanelResizerFrame.vue", 
        Component.esModule && Object.keys(Component.esModule).some(function(key) {
            return "default" !== key && "__esModule" !== key;
        }) && console.error("named exports are not supported in *.vue files."), Component.options.functional && console.error("[vue-loader] PanelResizerFrame.vue: functional components are not supported with templates, they should use render functions."), 
        exports.__esModule = !0, exports.default = Component.exports;
    }, function(module, exports, __webpack_require__) {
        var content = __webpack_require__(34);
        "string" == typeof content && (content = [ [ module.i, content, "" ] ]), content.locals && (module.exports = content.locals);
        __webpack_require__(1)("17bdd8c0", content, !1);
    }, function(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(0)(), exports.push([ module.i, "\n.vue-panel-resizer-frame {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  flex-flow: column;\n  position: relative;\n}\n.vue-panel-resizer-frame .vue-panel-resizer-frame-part {\n    display: flex;\n}\n.vue-panel-resizer-frame .vue-panel-resizer-frame-part.vue-panel-resizer-frame-part-center {\n      flex-basis: 100%;\n}\n.vue-panel-resizer-frame .vue-panel-resizer-frame-part.vue-panel-resizer-frame-part-center .vue-panel-resizer-frame-content {\n        flex-basis: 100%;\n        margin: 0;\n}\n", "", {
            version: 3,
            sources: [ "/./src/PanelResizerFrame.vue" ],
            names: [],
            mappings: ";AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;IACI,cAAc;CACjB;AACD;MACM,iBAAiB;CACtB;AACD;QACQ,iBAAiB;QACjB,UAAU;CACjB",
            file: "PanelResizerFrame.vue",
            sourcesContent: [ "\n.vue-panel-resizer-frame {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  flex-flow: column;\n  position: relative;\n}\n.vue-panel-resizer-frame .vue-panel-resizer-frame-part {\n    display: flex;\n}\n.vue-panel-resizer-frame .vue-panel-resizer-frame-part.vue-panel-resizer-frame-part-center {\n      flex-basis: 100%;\n}\n.vue-panel-resizer-frame .vue-panel-resizer-frame-part.vue-panel-resizer-frame-part-center .vue-panel-resizer-frame-content {\n        flex-basis: 100%;\n        margin: 0;\n}\n" ],
            sourceRoot: "webpack://"
        } ]);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _const = __webpack_require__(3), _Resizer = __webpack_require__(6), _Resizer2 = function(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }(_Resizer);
        exports.default = {
            name: "VueJsPanelResizerFrame",
            components: {
                Resizer: _Resizer2.default
            },
            props: {
                minWidth: {
                    type: Number
                },
                maxWidth: {
                    type: Number
                },
                minHeight: {
                    type: Number
                },
                container: {
                    type: String
                },
                snapGridSize: {
                    type: Number
                },
                autoSnapToGrid: {
                    type: Boolean
                }
            },
            data: function() {
                return {
                    SizingHandleType: _const.SizingHandleType
                };
            },
            methods: {
                onResize: function(event) {
                    this.$emit("resize", event);
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        module.exports = {
            render: function() {
                var _vm = this, _h = _vm.$createElement, _c = _vm._self._c || _h;
                return _c("div", {
                    staticClass: "vue-panel-resizer-frame"
                }, [ _c("div", {
                    staticClass: "vue-panel-resizer-frame-part vue-panel-resizer-frame-part-center"
                }, [ _c("div", {
                    staticClass: "vue-panel-resizer-frame-content"
                }, [ _vm._t("default") ], 2), _vm._v(" "), _c("resizer", {
                    attrs: {
                        visible: !0,
                        "min-width": _vm.minWidth,
                        "max-width": _vm.maxWidth,
                        "min-height": _vm.minHeight,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid,
                        type: _vm.SizingHandleType.Right
                    },
                    on: {
                        resize: _vm.onResize
                    }
                }) ], 1) ]);
            },
            staticRenderFns: []
        }, module.exports.render._withStripped = !0;
    }, function(module, exports, __webpack_require__) {
        module.exports = {
            render: function() {
                var _vm = this, _h = _vm.$createElement, _c = _vm._self._c || _h;
                return _c("div", {
                    staticClass: "vue-panel-resizer"
                }, [ _c("div", {
                    directives: [ {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.lhsVisible,
                        expression: "lhsVisible"
                    } ],
                    staticClass: "vue-panel-resizer-lhs v--modal-box",
                    style: _vm.lhsStyle
                }, [ _c("panel-resizer-frame", {
                    attrs: {
                        "min-width": _vm.minWidth,
                        "max-width": _vm.maxWidth,
                        "min-height": 0,
                        container: _vm.container,
                        "snap-grid-size": _vm.snapGridSize,
                        "auto-snap-to-grid": _vm.autoSnapToGrid
                    },
                    on: {
                        resize: _vm.onResize
                    }
                }, [ _vm._t("left") ], 2) ], 1), _vm._v(" "), _c("div", {
                    staticClass: "vue-panel-resizer-rhs"
                }, [ _vm._t("right") ], 2) ]);
            },
            staticRenderFns: []
        }, module.exports.render._withStripped = !0;
    } ]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/tombola-vue-js-modal/dist/index.js
// module id = dzIG
// module chunks = 0